// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodTasterId = (z.number());
export const foodTaster = z.object({
    id: foodTasterId,
    email: z.string().nullable(),
    name: z.string().nullable(),
    organisation: z.string().nullable(),
    role: z.string().nullable(),
    operator_id: operatorId.nullable(),
    erased_at: z.date().nullable(),
    erased_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    last_updated_by: operatorId.nullable(),
});
export const foodTasterInitializer = z.object({
    id: foodTasterId.optional(),
    email: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    organisation: z.string().optional().nullable(),
    role: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    erased_at: z.date().optional().nullable(),
    erased_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    last_updated_by: operatorId.optional().nullable(),
});
export const foodTasterMutator = z.object({
    id: foodTasterId.optional(),
    email: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    organisation: z.string().optional().nullable(),
    role: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    erased_at: z.date().optional().nullable(),
    erased_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodTaster.js.map